import { render, staticRenderFns } from "./BulletinList.vue?vue&type=template&id=aaf332e6&scoped=true"
import script from "./BulletinList.vue?vue&type=script&lang=js"
export * from "./BulletinList.vue?vue&type=script&lang=js"
import style0 from "./BulletinList.vue?vue&type=style&index=0&id=aaf332e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf332e6",
  null
  
)

export default component.exports